<template>
  <div
    v-if="visible"
    id="column-modal"
  >
    <modal @close="close">
      <div class="modal-dialog column-modal">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="close()"
            >
              <span>×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <p class="heading col-sm-7">
                {{ column.title }}
              </p>
              <p class="modified col-sm-5">
                最終更新日{{ column.media_date }}
              </p>
            </div>
            <p class="sub-heading">
              {{ column.sub_title }}
            </p>
            <!-- eslint-disable vue/no-v-html -->
            <p
              class="content"
              v-html="column.content"
            />
            <!-- eslint-enable vue/no-v-html -->
            <div
              v-if="column.image"
              class="eye-catching"
            >
              <img :src="column.image">
            </div>
            <p class="caution">
              こちらの投稿はプレスリリースではありません。
            </p>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "~/components/Readers/Modal";
export default {
  name: "ColumnModal",
  components: { Modal },
  props: {
    column: {
      type: Object,
      require: false,
      default: () => {}
    },
    visible: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("closeModal");
    }
  }
};
</script>

<style scoped lang="scss">
.column-modal  {
  .modal-content {
    margin: 0 auto;
    width: 100%;
  }

  .modal-body {
    width: 100%;
    padding: 40px;
    overflow: hidden;

    @media (max-width: 767px) {
      width: 280px;
      padding: 20px;
      // TODO: テキストが長い場合の表示デザインを変える
      // - はみ出し
      // - 縦幅
      overflow: hidden;
      box-sizing: content-box;
    }

    .row {
      margin: 0;
    }

    p {
      word-break: break-all;
    }

    .heading {
      margin: 0;
      padding: 0;
      width: 70%;
      font-size: 32px;
      font-weight: bold;
      color: #00c300;
      font-family:
        "Hiragino Mincho ProN",
        "ヒラギノ明朝 Pro W6",
        "Hiragino Mincho Pro",
        "HGS明朝E",
        "ＭＳ Ｐ明朝",
        serif !important;

      @media (max-width: 767px) {
        font-size: 24px;
        width: 100%;
      }
    }

    .modified {
      margin: 0;
      padding: 12px 0 0 0;
      width: 30%;
      font-size: 12px;
      text-align: right;

      @media (max-width: 767px) {
        padding: 6px 0 0 0;
        text-align: left;
        width: 100%;
        font-size: 10px;
      }
    }

    .sub-heading {
      margin: 30px 0 0 0;
      width: 100%;
      font-size: 20px;
      font-weight: bold;
      font-family:
        "Hiragino Mincho ProN",
        "ヒラギノ明朝 Pro W6",
        "Hiragino Mincho Pro",
        "HGS明朝E",
        "ＭＳ Ｐ明朝",
        serif !important;

      @media (max-width: 767px) {
        font-size: 18px;
      }
    }

    .content {
      margin: 15px 0 0 0;
      width: 100%;
      max-height: 400px;
      overflow-y: scroll;
      font-size: 16px;
      line-height: 1.8em;
      font-family:
        "Hiragino Mincho ProN",
        "ヒラギノ明朝 Pro W6",
        "Hiragino Mincho Pro",
        "HGS明朝E",
        "ＭＳ Ｐ明朝",
        serif !important;
    }

    .eye-catching {
      margin: 20px 0;
      text-align: center;
      width: 100%;

      @media (max-width: 767px) {
        width: 280px;
      }
    }

    .eye-catching img {
      max-width: 100%;
      max-height: 500px;
      border-radius: 3px;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
    }

    .caution {
      padding: 5px 10px;
      margin: 0;
      background-color: #ededed;
      font-size: 12px;
      border-radius: 2px;
      -webkit-border-radius: 2px;
      -moz-border-radius: 2px;

      @media (max-width: 767px) {
        font-size: 11px;
      }
    }
  }
}
</style>
